
import React from 'react';
import AffiliateOverviewTab from '@/components/affiliate/AffiliateOverviewTab';
import { useAuth } from '@/contexts/AuthContext';

const AffiliateDashboard = () => {
  const { profile } = useAuth();
  
  // Show login prompt if user is not authenticated
  if (!profile?.id) {
    return (
      <div className="p-6 space-y-6">
        <div className="flex items-center justify-center min-h-[400px]">
          <div className="text-center">
            <h3 className="text-lg font-medium text-gray-900 mb-2">Authentication Required</h3>
            <p className="text-gray-600 mb-4">Please log in as an affiliate to view dashboard.</p>
            <p className="text-sm text-gray-500">Log in as: nancy+aff@scoutforce.com</p>
          </div>
        </div>
      </div>
    );
  }
  
  return (
    <div className="p-6 space-y-6">
      <div>
        <h1 className="text-3xl font-heading font-bold text-primary-700">Affiliate Overview</h1>
        <p className="text-gray-600">
          Welcome back, {profile?.name || 'Affiliate'}. Here's your performance summary.
        </p>
      </div>

      <AffiliateOverviewTab />
    </div>
  );
};

export default AffiliateDashboard;
